<script setup lang="ts">
import type { PropType } from 'vue';

const props = defineProps({
  nft: { type: Object as PropType<any>, default: () => undefined },
  side: { type: Number as PropType<1 | 2>, default: () => undefined },
  primary: { type: Boolean, default: () => true },
});
const { nft, side } = toRefs(props);
</script>
<template>
  <NuxtLink
    :to="`/offers/upload?nft=${nft.encoded_id}&side=${side || 1}`"
    :class="[
      primary
        ? ' bg-black text-white dark:bg-neutral-100 dark:text-black'
        : ' bg-white text-black dark:border-[#303030] dark:bg-neutral-800 dark:text-white',
    ]"
    class="betterhover:hover:shadow-card-hover flex w-full justify-center rounded-full border border-transparent px-4 py-3 font-semibold transition duration-100 ease-in-out betterhover:hover:-translate-y-0.5"
  >
    <slot></slot>
  </NuxtLink>
</template>
